// Build time-utils.js with `tsc -t es2020 -m commonjs time-utils.ts --outDir ../dev`
export namespace Epoch {
  export class seconds {
    public static get decimal(): number {
      return Date.now() / 1000;
    }

    public static get floor(): number {
      return Math.floor(this.decimal);
    }

    public static get ceil(): number {
      return Math.ceil(this.decimal);
    }

    public static get round(): number {
      return Math.round(this.decimal);
    }
  }
}
